import { Component, Input, inject, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { BannerState } from './state/banner-state.model';
import { EMediaBreakpoint } from 'projects/shared/lib/enum/media/media-breakpoint.enum';
import { IMediaService, IMediaServiceToken } from 'shared/services/ui/media/media-service.interface';
import { CommonModule } from '@angular/common';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { IBannerService, IBannerServiceToken } from 'shared/services/ui/banner/banner-service.interface';
import { ENVIRONMENT } from 'shared/environment/environment';

@Component({
  selector: 'app-banner',
  imports: [
    CommonModule,
    BreadcrumbComponent,
  ],
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss']
})
export class BannerComponent implements OnInit, OnDestroy {
  public bannerState?: BannerState | undefined;

  private readonly bannerService: IBannerService = inject(IBannerServiceToken);
  private bannerStateSubscription?: Subscription | undefined;

  private readonly mediaService: IMediaService = inject(IMediaServiceToken);
  private mediaBreakpointSubscription: Subscription | undefined;

  public eMediaBreakpoint: typeof EMediaBreakpoint;
  public mediaBreakpoint: EMediaBreakpoint;

  public displayBannerDefault: boolean;
  public displayBannerMunhowen: boolean;

  public constructor() {
    this.eMediaBreakpoint = EMediaBreakpoint;
    this.mediaBreakpoint = this.mediaService.mediaBreakpointGet();

    this.displayBannerDefault = ENVIRONMENT.user.displayBannerDefault != undefined ? ENVIRONMENT.user.displayBannerDefault : true;
    this.displayBannerMunhowen = ENVIRONMENT.user.displayBannerMunhowen != undefined ? ENVIRONMENT.user.displayBannerMunhowen : false;
  }

  public ngOnInit(): void {

    this.bannerStateSubscriptionInit();

    if (this.mediaBreakpointSubscription == undefined) {
      this.mediaBreakpointSubscription = this.mediaService.mediaBreakpointChangeGet().subscribe(
        (mediaBreakpoint: EMediaBreakpoint) => {
          setTimeout(() => {
            this.mediaBreakpoint = mediaBreakpoint;
          });
        }
      );
    }
  }

  public ngOnDestroy(): void {
    this.bannerStateSubscription?.unsubscribe();
  }

  bannerStateSubscriptionInit() {
    if (this.bannerStateSubscription == undefined) {
      this.bannerStateSubscription = this.bannerService.bannerStateChangedGet().subscribe(
        (bannerState: BannerState | undefined) => {
          setTimeout(() => {
            this.bannerState = bannerState;
          });
        }
      );
    }
  }

}